import React, { useState, memo, useEffect } from "react";
// import { EditButton } from "./styles/EditPermissionsStyle";
import { toast } from "react-hot-toast";
// import EditPermissionsPopup from "./EditPermissionsPopup";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { DialogMain, IconButtonMain } from "../accounting/styles/DialogStyles";
import { DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FormMain, PermissionsMain } from "./styles/NewUserPopupStyle";
import SelectPermissions from "./SelectPermissions";
import { CustomLabel } from "../../shared/commonstyle/PhoneStyle";
import MainButton from "../../shared/Button";
import {
  GetComePermissions,
  GetPermissions,
  UpdatePermissions,
} from "../../../services/admin/agents";
import SmallLoader from "../../shared/loader/SmallLoader";
import { UpdatedAgent } from "../../../redux/slice/admin/agents/AgentsSlice";
import { useDispatch } from "react-redux";

const validationSchema = Yup.object().shape({
  permissions: Yup.array().min(1, "Select at least one permission"),
});

const EditPermissions = ({
  openDialog = false,
  handleCloseDialog = () => {},
  selectRowData = {},
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Btnloading, setBtnloading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (openDialog) {
      handleFetchAllPermissions();
    }
  }, [openDialog]);

  const handleFetchAllPermissions = async () => {
    try {
      setLoading(true);
      const resp = await GetPermissions();
      if (resp?.status === 200 && resp?.data?.message === "Success") {
        const formattedOptions = resp?.data?.data?.map((item) => ({
          value: item?.id,
          label: item?.name,
        }));
        setOptions(formattedOptions);

        // show the selected options
        const permissions = selectRowData?.Permissions;
        if (permissions) {
          const namesToFilter = permissions.split(",");
          const filteredData = resp?.data?.data?.filter((item) =>
            namesToFilter.includes(item.name)
          );
          const filteredOptions = filteredData?.map((item) => ({
            value: item?.id,
            label: item?.name,
          }));
          setSelectedOptions(filteredOptions || []);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const selectAllOption = {
    value: "select-all",
    label: "Select All",
  };
  const selectOptions = [selectAllOption, ...options];

  const PermissionshandleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);

    // Check if "Select All" option is selected

    const selectAllOption = options.find(
      (option) => option.value === "select-all"
    );
    if (selectedOptions?.some((option) => option.value === "select-all")) {
      // Select or deselect all options based on the "Select All" checkbox
      setSelectedOptions(
        selectedOptions.length === options.length ? [] : options
      );
    }
  };

  const initialValues = {
    permissions: selectedOptions || [],
  };

  const handleSubmit = async (values) => {
    const selectedOptionIds = selectedOptions
      .map((option) => option.value)
      .join(",");

    const DataObj = {
      abilities: selectedOptionIds,
    };
    const res = await UpdatePermissions(
      setBtnloading,
      selectRowData?.id,
      DataObj
    );
    if (res?.status === 200 && res?.data?.message === "Success") {
      const retuenvalue = {
        id: res?.data?.data?.slug,
        name: res?.data?.data?.name,
        email: res?.data?.data?.email,
        Permissions: GetComePermissions(res?.data?.data?.permissions),
      };
      dispatch(UpdatedAgent(retuenvalue));
      handleCloseDialog();
      toast.success("Updated Successfully");
    }
  };

  return (
    <>
      {/* <EditButton onClick={handleOpenDialog}>Edit Permissions</EditButton> */}
      {/* <EditPermissionsPopup
        open={openDialog}
        handleClose={handleCloseDialog}
        RowID={Row}
      /> */}
      <DialogMain open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>
          <div className="headerMain">
            <div className="title">
              <h6 style={{ fontWeight: "bold" }}>Edit Permissions</h6>
            </div>
            <div className="closeBtn">
              <IconButtonMain onClick={handleCloseDialog}>
                <CloseIcon />
              </IconButtonMain>
            </div>
          </div>
        </DialogTitle>

        {loading && <SmallLoader center={true} />}
        {loading && (
          <>
            <br />
          </>
        )}
        {!loading && (
          <>
            <DialogContent>
              <FormMain>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {(formik) => (
                    <Form autocomplete="off">
                      <CustomLabel>Permissions</CustomLabel>
                      <PermissionsMain
                        className={
                          formik.touched.permissions &&
                          formik.errors.permissions &&
                          "haveError"
                        }
                      >
                        <Field name="permissions">
                          {({ field, form }) => (
                            <SelectPermissions
                              options={selectOptions}
                              selectedOption={selectedOptions}
                              handleChange={(selectedOptions) => {
                                formik.setFieldValue(
                                  "permissions",
                                  selectedOptions
                                );
                                PermissionshandleChange(selectedOptions);
                              }}
                              name="permissions"
                              onBlur={formik.handleBlur}
                            />
                          )}
                        </Field>

                        {formik.touched.permissions &&
                          formik.errors.permissions && (
                            <span className="error">
                              {formik.errors.permissions}
                            </span>
                          )}
                      </PermissionsMain>
                      <MainButton
                        type="submit"
                        label="Update"
                        isLoading={Btnloading}
                      />
                    </Form>
                  )}
                </Formik>
              </FormMain>
            </DialogContent>
          </>
        )}
      </DialogMain>
    </>
  );
};

export default memo(EditPermissions);
